import "./About.css";
import { SECTIONS } from "../../data";

export default function About() {
  return (
    <div className="about-container" id={SECTIONS.ABOUT}>
      <h1 className="about-title">About</h1>
      <span>
        I'm Yakup, a passionate{" "}
        <span className="bolded"> Software Engineer </span> with a background in
        <span className="bolded"> Computer Engineering </span> and a minor in
        <span className="bolded"> Applied Data Analytics, </span> I specialize
        in crafting intuitive digital experiences and optimizing software
        systems.
      </span>
      <span>
        Throughout my career, I've had the opportunity to work on diverse
        projects, ranging from
        <span className="bolded">
          {" "}
          mobile application development to front-end optimization{" "}
        </span>
        and <span className="bolded"> system architecture enhancements. </span>
        Leveraging my expertise in technologies like
        <span className="bolded"> React Native, React.js, Node.js, </span> and
        more, I've spearheaded the development of user-friendly applications and
        streamlined codebases for enhanced performance.
      </span>
      <span>
        Driven by a thirst for learning and problem-solving, I actively
        <span className="bolded">
          {" "}
          contribute to open-source projects on GitHub and Stackoverflow{" "}
        </span>
        and enjoy honing my coding skills on platforms like
        <span className="bolded"> HackerRank </span> and
        <span className="bolded"> LeetCode</span>. Fluent in English, Turkish,
        and my native language Turkmen, I thrive in multicultural environments
        and love collaborating with diverse teams to innovate and make a
        positive impact.
      </span>
      <span>
        Let's connect and explore how we can leverage technology to bring your
        ideas to life!
      </span>
    </div>
  );
}
